import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { FONT, COLORS3 as COLORS, SPACING, MEDIA_QUERY } from '../../styles/emotion';
import CaretV2Icon from '../SvgIcons/CaretV2';

export const AccordionV2Container = styled.div`
  ${MEDIA_QUERY.DESKTOP} {
    display: flex;
  }
`;

export const TitleContainer = styled.div`
  ${MEDIA_QUERY.DESKTOP} {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 214px;
    margin-right: ${SPACING.MD};
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    flex-basis: 372px;
  }
  ${MEDIA_QUERY.DESKTOP_XL} {
    flex-basis: 420px;
  }
`;

export const Title = styled.h2`
  font-family: ${FONT.FONT_FAMILY_SERIF};
  font-size: ${FONT.FONT_SIZE_LARGER};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  letter-spacing: -1.3px;
  line-height: 100%;
  margin: 0 0 ${SPACING.LG} 0;

  ${MEDIA_QUERY.DESKTOP} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGER)}
    letter-spacing: -0.04em;
    margin-bottom: 0;
  }
`;

export const AccordionBody = styled.div`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}
  padding-bottom: ${SPACING.MD};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  color: ${COLORS.BLACK_075};

  p:last-of-type {
    margin-bottom: 0;
  }
`;

export const AccordionSectionHeadingContainer = styled.div`
  margin: 0;
  padding: 0;
`;

export const AccordionSectionHeading = styled.h3`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  color: ${COLORS.BLACK_100};
  margin-bottom: 0;
  text-align: left;
`;

export const AccordionButton = styled.button<{ arrowOnLeft?: boolean }>`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${COLORS.BLACK_100};
  display: flex;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  justify-content: space-between;
  margin: 0;
  outline: none;
  padding: ${SPACING.MD} 0;
  width: 100%;

  // show outline for keyboard users
  &:focus-visible {
    outline: 5px auto -webkit-focus-ring-color;
  }

  ${({ arrowOnLeft }) =>
    arrowOnLeft &&
    css`
      flex-direction: row-reverse;
      justify-content: flex-end;
    `};
`;

const sectionOpenAndHoverStyles = css`
  color: ${COLORS.BLACK_100};
  cursor: pointer;
`;

export const AccordionSection = styled.section<{ isOpen?: boolean }>`
  border-bottom: solid 1px ${COLORS.BLACK_030};
  padding: 0 ${SPACING.MD};

  ${MEDIA_QUERY.MOBILE} {
    padding: 0;
  }

  &:hover,
  &:focus-visible {
    ${AccordionSectionHeading}, ${AccordionButton} {
      ${sectionOpenAndHoverStyles};
      text-decoration: underline;
    }
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      ${AccordionSectionHeading}, ${AccordionButton} {
        ${sectionOpenAndHoverStyles};
      }
    `};
`;

export const Accordion = styled.div`
  flex: auto;

  ${AccordionSection}:first-of-type {
    border-top: solid 1px ${COLORS.BLACK_030};
  }
`;

export const StyledCaret = styled(CaretV2Icon, {
  shouldForwardProp: (prop) => prop !== 'arrowOnLeft',
})<{ arrowOnLeft?: boolean }>`
  margin: 0;

  height: ${FONT.FONT_SIZE_SMALL};
  width: ${FONT.FONT_SIZE_SMALL};
  color: ${COLORS.BLACK_100};
  margin-right: 0;
  margin-left: ${SPACING.MD};
  transition: transform 0.2s ease;

  ${({ arrowOnLeft }) =>
    arrowOnLeft &&
    css`
      margin-right: ${SPACING.MD};
      margin-left: 0;
    `};
`;
